import { render } from "./DatePicker.vue?vue&type=template&id=b5c1844e&scoped=true"
import script from "./DatePicker.vue?vue&type=script&lang=js"
export * from "./DatePicker.vue?vue&type=script&lang=js"

import "./DatePicker.vue?vue&type=style&index=0&id=b5c1844e&lang=sass&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b5c1844e"]])

export default __exports__